import { ETemplateStudioLayoutOptions } from 'components/TemplatesStudio/enums';

import type { FreeTilesLayout } from './contracts';

export enum EBlockType {
  BUNDLE = 'Bundle',
  PROMOTION = 'Promotion',
  ROLLING_OFFER = 'RollingOffer',
  ONE_PLUS_MANY = 'OnePlusMany',
  DAILY_BONUS = 'DailyBonus',
  REWARD_CALENDAR = 'RewardCalendar',
  TRIGGERED_POPUP = 'TriggeredPopup',
  PROGRESS_BAR = 'ProgressBar',
  RICH_TEXT = 'RichText'
}

export interface StoreBlockMaxOffers {
  unlimited: boolean;
  value?: number;
}

export interface IBaseStoreBlock {
  id: string;
  type: EBlockType;
  isVisible: boolean;
  mergedTo?: string[];
  selectedDesignId?: string;
  themes?: string[];
}

export interface IBundleStoreBlock extends IBaseStoreBlock {
  type: EBlockType.BUNDLE;
  offersPerRow?: number;
  bundleViewModel?: string;
}

export interface IPromotionStoreBlock extends IBaseStoreBlock {
  type: EBlockType.PROMOTION;
}

export interface IProgressBarStoreBlock extends IBaseStoreBlock {
  type: EBlockType.PROGRESS_BAR;
}

export interface IRollingOfferStoreBlock extends IBaseStoreBlock {
  type: EBlockType.ROLLING_OFFER;
  desktopLayout: ETemplateStudioLayoutOptions;
}

export interface IOnePlusManyStoreBlock extends IBaseStoreBlock {
  type: EBlockType.ONE_PLUS_MANY;
  desktopLayout: ETemplateStudioLayoutOptions;
  maxOffers: StoreBlockMaxOffers;
  rewardsLayout: FreeTilesLayout;
}

export interface IDailyBonusStoreBlock extends IBaseStoreBlock {
  type: EBlockType.DAILY_BONUS;
  selectedBadgeDesignId?: string;
  badgeThemes?: string[];
}

export interface IRewardCalendarStoreBlock extends IBaseStoreBlock {
  type: EBlockType.REWARD_CALENDAR;
  selectedBadgeDesignId?: string;
}

export interface ITriggeredPopupStoreBlock extends IBaseStoreBlock {
  type: EBlockType.TRIGGERED_POPUP;
  selectedBadgeDesignId?: string;
}

export interface IRichTextStoreBlock extends IBaseStoreBlock {
  type: EBlockType.RICH_TEXT;
  text?: string;
  fontColor?: string;
}

export type TStoreBlock =
  | IBundleStoreBlock
  | IPromotionStoreBlock
  | IProgressBarStoreBlock
  | IRollingOfferStoreBlock
  | IOnePlusManyStoreBlock
  | IDailyBonusStoreBlock
  | IRewardCalendarStoreBlock
  | ITriggeredPopupStoreBlock
  | IRichTextStoreBlock;
